export type TableProps = {
  tableTitle?: string;
  tableBody: Array<{
    rowHead: string;
    rowData: [string, string, string];
  }>;
};
export type PricingTablesProps = {
  heading: string;
  tables: TableProps[];
};

export const pricingTables: PricingTablesProps[] = [
  {
    heading: "Product Features",
    tables: [
      {
        tableTitle: "Data Activation",
        tableBody: [
          {
            rowHead: "Reverse ETL Platform",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Customer Studio Platform",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Match Booster",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Personalization API",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
      {
        tableTitle: "Data Management",
        tableBody: [
          {
            rowHead: "Hightouch Events",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Warehouse Identity Resolution",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Campaign Intelligence",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
    ],
  },
  {
    heading: "Product Usage",
    tables: [
      {
        tableBody: [
          {
            rowHead: "# of standard destinations",
            rowData: ["1", "2", "Unlimited"],
          },
          {
            rowHead: "# of active syncs per standard destination",
            rowData: ["Up to 2", "Up to 5", "Custom"],
          },
          {
            rowHead: "# of destinations 30-day free trials",
            rowData: ["Unlimited", "Unlimited", "Unlimited"],
          },
          {
            rowHead: "# of syncs to lite destinations",
            rowData: ["25", "25", "Custom"],
          },
          {
            rowHead: "# of data fields",
            rowData: ["Unlimited", "Unlimited", "Unlimited"],
          },
          {
            rowHead: "# of sources",
            rowData: ["Unlimited", "Unlimited", "Unlimited"],
          },
          {
            rowHead: "# of source rows",
            rowData: ["Unlimited", "Unlimited", "Unlimited"],
          },
          {
            rowHead: "# of sync runs per month",
            rowData: ["Unlimited", "Unlimited", "Unlimited"],
          },
          {
            rowHead: "# of user seats",
            rowData: ["5", "5", "Unlimited"],
          },
          {
            rowHead: "# of workspaces",
            rowData: ["1", "2", "Unlimited"],
          },
          {
            rowHead: "Access to premium destinations (NetSuite, SFMC, etc.)",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Realtime syncing (sub-hourly)",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Warehouse Identity Resolution",
            rowData: ["N/A", "N/A", "Custom"],
          },
          {
            rowHead: "Hightouch Events",
            rowData: ["N/A", "N/A", "Custom"],
          },
        ],
      },
    ],
  },
  {
    heading: "Observability & Planning",
    tables: [
      {
        tableTitle: "Observability",
        tableBody: [
          {
            rowHead: "Live debugger",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Test runs (test-a-row)",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Basic alerting",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Custom alerting (by sync)",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "In-app sync logs",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Warehouse sync logs",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
      {
        tableTitle: "Sync Planning and Caching",
        tableBody: [
          {
            rowHead: "Run on Hightouch",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Run on your warehouse",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Run on your custom storage",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
    ],
  },
  {
    heading: "Extensions",
    tables: [
      {
        tableTitle: "Platform extensions",
        tableBody: [
          {
            rowHead: "dbt model selector (git repo)",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "dbt Cloud sync scheduler",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Fivetran sync scheduler",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Looker model selector",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Tableau integration",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Sigma workbook integration",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
    ],
  },
  {
    heading: "Enterprise Security & Management",
    tables: [
      {
        tableTitle: "Security & Privacy",
        tableBody: [
          {
            rowHead: "SOC 2 compliance",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "SOC 3 compliance",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "GDPR Compliance",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "HIPAA compliance",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Deployment in EU region",
            rowData: ["N/A", "check", "check"],
          },
          {
            rowHead: "Deployment in multiple regions",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "SSH tunneling",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "Custom Security Review (BAA, DPA, full SOC2 report)",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
      {
        tableTitle: "Access Management",
        tableBody: [
          {
            rowHead: "Role-based access control",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Label-based access control",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Google and Azure SSO",
            rowData: ["check", "check", "check"],
          },
          {
            rowHead: "SAML SSO (Okta, Azure AD, OneLogin, etc.)",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
      {
        tableTitle: "Platform Management",
        tableBody: [
          {
            rowHead: "Git version control",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Approval Flows",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Audit Logs",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Resource API",
            rowData: ["check", "check", "check"],
          },
        ],
      },
    ],
  },
  {
    heading: "Support & Services",
    tables: [
      {
        tableTitle: "Support",
        tableBody: [
          {
            rowHead: "Dedicated shared Slack",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Dedicated CSM",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "White glove onboarding",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Dedicated services",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Dedicated solutions architect",
            rowData: ["N/A", "N/A", "check"],
          },
        ],
      },
      {
        tableTitle: "Service-Level Agreements (SLAs)",
        tableBody: [
          {
            rowHead: "Custom product uptime SLA",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Custom support SLA",
            rowData: ["N/A", "N/A", "check"],
          },
          {
            rowHead: "Email and Intercom support",
            rowData: ["72-hour SLA", "72-hour SLA", "Custom"],
          },
        ],
      },
    ],
  },
];
